import { Button } from '@wartek-id/button-v1'
import type { DialogProps } from '@wartek-id/dialog-v1'
import {
  Dialog,
  DialogCloseButton,
  DialogContent,
  DialogOverlay,
} from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

import { assetUrl } from 'utils/url'

interface DialogFinalizeSKPProps extends Omit<DialogProps, 'children'> {
  isFinalizing?: boolean
  onClickFinalize?: () => any
  onClickCancel?: () => any
  satuanPendidikan: string
}

const DialogFinalizeSKP = ({
  isFinalizing,
  onClickFinalize = () => {},
  onClickCancel = () => {},
  ...props
}: DialogFinalizeSKPProps) => {
  return (
    <Dialog {...props}>
      <DialogOverlay />
      <DialogContent>
        <DialogCloseButton data-testid="btn-close" />
        <div className="p-6">
          <img
            src={assetUrl('/illustrations/img-publish-data.png')}
            className="flex-shrink-0 flex-grow-0"
            alt=""
            width={84}
            height={84}
          />
          <Text variant="display-sm" className="mt-4">
            Konfirmasi untuk Ajukan Perencanaan
          </Text>
          <Text color="subdued" className="mt-4 !text-xl">
            Perencanaan tidak dapat diubah lagi dan akan diperiksa oleh Kepala
            Sekolah.
          </Text>

          <div className="flex gap-5 mt-5">
            <Button
              size="lg"
              color="white"
              disabled={isFinalizing}
              isLoading={isFinalizing}
              onClick={() => onClickCancel()}
              data-testid="btn-cancel"
              className="flex-1"
            >
              Kembali
            </Button>
            <Button
              size="lg"
              className="flex-1"
              disabled={isFinalizing}
              isLoading={isFinalizing}
              onClick={() => onClickFinalize()}
              data-testid="btn-confirm"
            >
              Konfirmasi
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default DialogFinalizeSKP
